import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, BoxProps } from 'components/ui';

export const ProductDetailBackArrowContainer = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.productDetailBackArrowContainer, style]} />
);

const styles = StyleSheet.create({
  productDetailBackArrowContainer: {
    left: 16,
    position: 'absolute',
  },
});
